"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_context_selector_1 = require("use-context-selector");
var PopoverContext = (0, use_context_selector_1.createContext)({
    setState: function () { return function () { return null; }; },
    openedTarget: null
});
exports.default = PopoverContext;
